import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable, throwError } from 'rxjs';
import { AuthService } from 'src/app/Services/services/auth.service';
import { UserAuthManager } from 'src/app/Services/user-sessions/user-auth-manager';
import {
  HttpErrorUtil,
  HttpUnauthorizedException,
} from 'src/app/utils/http-util/http-error.util';
import { CourseManagementHttpService } from './course-http.service';
import { catchError, map } from 'rxjs/operators';
import { IGetCodes } from 'src/app/interfaces/codes';
import { BaseSvcService } from 'src/app/Services/config/base-svc.service';
import { SessionService } from 'src/app/Services/session.service';
import { IAvailableFeature } from '../course-feature-availabillity-modal/course-feature-availabillity-modal.component';
import { ICheckCourseExistsRequest } from './course-http.service';

@Injectable({ providedIn: 'root' })
export class CourseManagementService {

  public url: string;

  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly toaster: ToastrService,
    private readonly courseManagementHttpService: CourseManagementHttpService,
    private http :HttpClient,
    private config: BaseSvcService,
    public session: SessionService,
  ) {
    this.url = this.config.activeURL;
  }

  public getDropdownList<T>(code: string) {
    return this.courseManagementHttpService
      .getDropdownListByCode<T>(code)
      .pipe(catchError((err: HttpErrorResponse) => this.handlerError(err)));
  }

  public getCourses<T>(
    loggedInUserId: string,
    courseMasterID: string,
    courseId: string | null,
    screenName: string,
    studentId: string | null
  ) {
    return this.courseManagementHttpService
      .getCourses<T>(
        loggedInUserId,
        courseMasterID,
        courseId,
        screenName,
        studentId
      )
      .pipe(catchError((err: HttpErrorResponse) => this.handlerError(err)));
  }

  createOrUpdateCourse<T>(formData: FormData) {
    return this.courseManagementHttpService
      .createOrUpdateCourse<T>(formData)
      .pipe(catchError((err: HttpErrorResponse) => this.handlerError(err,'Course')));
  }

  cloneCourse<T>(formData: FormData) {
    return this.courseManagementHttpService
      .cloneCourse<T>(formData)
      .pipe(catchError((err: HttpErrorResponse) => this.handlerError(err)));
  }

  performCourseCloning<T>(payload: ICheckCourseExistsRequest) {
    return this.courseManagementHttpService
      .performCourseCloning<T>(payload)
      .pipe(catchError((err: HttpErrorResponse) => this.handlerError(err)));
  }

  checkCourseExists<T>(payload: ICheckCourseExistsRequest) {
    return this.courseManagementHttpService
      .checkCourseExists<T>(payload)
      .pipe(catchError((err: HttpErrorResponse) => this.handlerError(err)));
  }

  getCourseMaster<T>(
    loggedInUserId: string,
    examAgencyId: number,
    courseMasterId: string
  ) {
    return this.courseManagementHttpService
      .getCourseMaster<T>(loggedInUserId, examAgencyId, courseMasterId)
      .pipe(
        catchError((err: HttpErrorResponse) => this.handlerError(err)),
        map((data) => {
          return data;
        })
      );
  }

  getCoursePlans<T>(
    loggedInUserId: string,
    courseId: number,
    coursePlanId: number |null,
    screenName: string,
    studentId: string|null,
    listType: string |null
  ) {
    return this.courseManagementHttpService
      .getCoursePlan<T>(
        loggedInUserId,
        courseId,
        coursePlanId,
        screenName,
        studentId,
        listType
      )
      .pipe(
        catchError((err: HttpErrorResponse) => this.handlerError(err)),
        map((data:any) => {
          return data?.PlanAndFeatures;
        })
      );
  }

  createOrUpdateCoursePlan(formData: FormData) {
    return this.courseManagementHttpService
      .createOrUpdateCoursePlan(formData)
      .pipe(
        catchError((err: HttpErrorResponse) => this.handlerError(err)),
        map((data) => {
          return data;
        })
      );
  }


  getFeaturesForCoursePlan(code: string): Observable<IGetCodes[]> {
    return this.http
      .get<{ resultList: IGetCodes[] }>(`${this.url}api/GetCodes/${code}`)
      .pipe(map((response) => response.resultList));
  }
  getFeaturesForCoursePlanAvailable(payload: any): Observable<IAvailableFeature[]> {
    payload.LoggedInUser = this.session.getUser();
    return this.http
      .post<{ Result: IAvailableFeature[] }>(`${this.url}api/GetAvailableCourseFeature`,payload)
      .pipe(map((response) => response.Result));
  }
  insertOrUpdateAvailableCourseFeature(payload: any): Observable<any> {
    payload.LoggedInUser = this.session.getUser();
    return this.http
      .post<any>(`${this.url}api/InsertOrUpdateAvailableCourseFeature`, payload);
  }


  private handlerError(err: HttpErrorResponse,entity='') {
    const error = HttpErrorUtil.sanitizeError(err);

    if (error instanceof HttpUnauthorizedException) {
      UserAuthManager.userSessionLogout.next();
      this.authService.logout();
      this.router.navigate(['/login']);
      this.toaster.warning(error.message, 'Logout Successfully');
    } else {
      if(error.message.includes('duplicate')&&entity==='Course' ){
        this.toaster.error('Course name already exists in this Exam Year', 'Error');
      }else{

      this.toaster.error(error.message, 'Error');
      }
    }

    return throwError(error);
  }
}
